import React, {Component} from "react";
import FakturJualSearch from "../common/fakturJualSearch";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import Api from "../../../../../Services/Api";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync, getUserAccess} from "../../../../../Services/Utils";
import {HttpStatus} from "../../../../common/Constants";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {config} from "./config";
import FakturJualDGIFilter from "./fakturJualDGIFilter";
import FlexView from "react-flexview";
import FakturJualDetail from "../common/fakturJualDetail";
import {formGroup} from "../config";
import * as R from "ramda";
import M from "moment";

class FakturJualDGI extends Component {
    constructor(props) {
        super(props);
        this.initialSearchData = {
            tanggalInvoiceMulai: M().format("DD-MM-YYYY"),
            tanggalInvoiceAkhir: M().format("DD-MM-YYYY"),
        };
        this.initialPagination = {
            totalData: 1,
            page: 1,
            limit: 5,
        };
        this.state = {
            loading: false,
            filterVisible: false,
            detailVisible: false,
            selectedData: null,
            isEditable: false,
            submittedFilterData: {},
            filterData: {},
            searchData: this.initialSearchData,
            skipNextPaginationFetch: false,
            cabangOptions: [],
            mdOptions: [],
            mainDealer: null,
            tableColumns: this.getTableColumns(),
            dataTable: [],
            pagination: this.initialPagination,
            userAccess: null,
            isCanConfirm: false
        };
    }

    getTableColumns(access) {
        let columns = [...config.tableColumns];
        columns.push({
            name: "action",
            label: "Aksi",
            options: {
                customBodyRender: (_, tableMeta) => (
                    <FlexView hAlignContent="center" style={{gap: 10}}>
                        <SimpleButton
                            type="button"
                            category="action_button"
                            icon={<i style={{fontSize: 20, color:"red"}} className="fa fa-lg fa-eye"/>}
                            onClick={() => this.handleShowDetail(tableMeta.rowIndex, false)}
                        />
                        <SimpleButton
                            type="button"
                            disabled={!access?.createAccess}
                            category="action_button"
                            icon={<i style={{fontSize: 20, color: !access?.createAccess ? "gray" : "red"}} className="fa fa-lw fa-file"/>}
                            onClick={() => this.handleShowDetail(tableMeta.rowIndex, true)}
                        />
                        {/* <SimpleButton
                            type="button"
                            disabled={!this.state.userAccess.createAccess}
                            category="action_button"
                            icon={<i style={{fontSize: 20, color: 'red'}} className="fa fa-lw fa-paper-plane"/>}
                            onClick={() => this.handleShowDetail(tableMeta.rowIndex, true, true)}
                        /> */}
                    </FlexView>
                ),
                sort: false
            },
        })

        return columns;
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchMainDealer();
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (_, prevState) => {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) && !this.state.skipNextPaginationFetch
        ) {
            this.handleTriggerLoading();
            let {submittedFilterData, mainDealer} = this.state;
            let req = removeNullFields({
                ...submittedFilterData,
                mainDealer: mainDealer?.value
            })
            await this.fetchData(
                req,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.handleTriggerLoading();
        }
        if (this.state.skipNextPaginationFetch) {
            this.setState({skipNextPaginationFetch: false});
        }

        if(
            prevState.detailVisible !== this.state.detailVisible && 
            this.state.detailVisible && this.state.selectedData &&
            this.state.mainDealer
        ){
            this.fetchDataCabang({
                kodeCabang: this.state.mainDealer?.kodeCabang,
                ahmDealerCode: this.state.selectedData?.ahmDealerCode
            })
        }
    }

    fetchDataCabang = async (payload) => {
        // notes deploy 13 January : ganti ke hit api kode cabang seperti di nos
        // menunggu cr lanjutan karena masih 1/2 matang
        // let res = await fetchDataAsync({
        //     asyncFn: Api.create("NAGAMAS_MASTER_DATA").findCabangForSalesOrderDGI,
        //     menuName: "Faktur Jual - DGI",
        //     setError: this.props.setError,
        //     args: {
        //         ahmDealerCode: payload.ahmDealerCode,
        //         kodeCabang: payload.kodeCabang,
        //     }
        // })
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
            menuName: "Faktur Jual - DGI",
            setError: this.props.setError,
            args: {}
        })
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            // this.setState((prevState) => ({
            //     ...prevState,
            //     cabangOptions: res.data.data.map(c => mapToObjectDDL(c.namaDealer, c.kodeCabang)),
            // }));
            let filteredData = res.data.data.filter(
                item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
            );
            if (filteredData.length !== 0) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    cabangOptions: filteredData.map(item => mapToObjectDDL(item.namaDealer, item.kodeCabang)),
                }));
            }
        }
    };

    fetchMainDealer = async () => {
        let firstMd = null;
        let kodeCabang = this.props.menuAccess.map(data => data.idRefObj);
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMainDealerForSalesOrderDGI,
            setError: this.props.setError,
            menuName: "Faktur Jual - DGI",
            args: {
                kodeCabang: kodeCabang,
            }
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let {data} = res.data;
            let listMd = data.map(item => {
                let commonCabang = item.kodeCabang.filter(i => kodeCabang.includes(i));
                return {
                    value: item.supplierCode,
                    label: item.supplierName,
                    kodeCabang: commonCabang,
                    ahmDealerCode: item.ahmDealerCode
                }
            });
            if(listMd.length > 0){
                firstMd = listMd[0];
                const access = getUserAccess(this.props.menuAccess, firstMd?.kodeCabang[0] || null);
                this.setState((prevState) => ({
                    ...prevState,
                    mdOptions: listMd,
                    mainDealer: firstMd,
                    userAccess: access,
                    tableColumns: this.getTableColumns(access),
                }));
            }
        }
        if(firstMd?.value){
            this.setState({
              submittedFilterData: {
                mainDealer: firstMd?.value,
                ...this.state.searchData,
              },
            });
            await this.fetchData({
                mainDealer: firstMd?.value,
                ...this.state.searchData,
            });
        }
    };

    fetchData = async (filter = {}, page = this.state.pagination.page, limit = this.state.pagination.limit) => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").getDataSalesOrderDGI,
            setError: this.props.setError,
            menuName: "Faktur Jual - DGI",
            args: {
                filter,
                page,
                limit,
            },
        });


        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let data = res.data.data.map(item => {
                const [day, month, year] = item.tanggalInvoice.split("/");
                return {
                    ...item,
                    tanggalInvoice: M(new Date(+year, +month - 1, +day)).format("DD-MM-YYYY"),
                }
            });
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: !R.isEmpty(res.data.data) ? data : [],
                pagination: {
                    ...prevValue.pagination,
                    totalData: res.data.totalData,
                },
            }));
        }
    };

    handleShowDetail = (index, isEditable, isCanConfirm) => {
        this.setState((prevValue) => ({
            ...prevValue,
            detailVisible: !prevValue.detailVisible,
            selectedData: this.state.dataTable[index],
            isEditable: isEditable,
            isCanConfirm: !!isCanConfirm
        }));
    };

    handleModalFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleSubmitFilter = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            searchData: {},
            pagination: {
                ...prevValue.pagination,
                page: 1
            },
            skipNextPaginationFetch: true
        }));

        let {filterData, mainDealer} = this.state;
        let {dealerId, startTanggalInvoice, endTanggalInvoice, alamat, ...rest} = filterData;

        const request = removeNullFields({
            ...rest,
            mainDealer: mainDealer?.value,
            kodeCabang: dealerId,
            tanggalInvoiceMulai: startTanggalInvoice,
            tanggalInvoiceAkhir: endTanggalInvoice,
            alamatCustomer: alamat,
            kodeKota: getValueFromDDL(this.state.filterData, "kodeKota"),
            kodeKecamatan: getValueFromDDL(this.state.filterData, "kodeKecamatan"),
            kodeKelurahan: getValueFromDDL(this.state.filterData, "kodeKelurahan"),
            kodeTipeUnit: getValueFromDDL(this.state.filterData, "kodeTipeUnit"),
            kodeWarna: getValueFromDDL(this.state.filterData, "kodeWarna"),
        });
        
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: false,
            submittedFilterData: request,
            loading: false,
        }));
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: {
                ...prevValue.searchData,
                [name]: M(value, "DD-MM-YYYY").format("DD-MM-YYYY"),
            },
        }));
    };

    handleCabangChange = (name, value) => {
        const access = getUserAccess(this.props.menuAccess,value.kodeCabang[0]);
        this.setState(
          (prevValue) => ({
            ...prevValue,
            [name]: value,
            searchData: this.initialSearchData,
            skipNextPaginationFetch: true,
            filterData: {},
            userAccess: access,
            tableColumns: this.getTableColumns(access),
            pagination: {
              page: 1,
              limit: 5,
              totalData: 0,
            },
          }),
          async () => {
            this.handleTriggerLoading();
            await this.fetchData({
              mainDealer: value.value,
              ...this.initialSearchData,
            });
            this.handleTriggerLoading();
          },
        );
    };

    handleClickSearch = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            filterData: {},
        }));

        let {mainDealer, mdOptions} = this.state;
        let md = mainDealer ? mainDealer : mdOptions[0];

        const request = removeNullFields({
            tanggalInvoiceMulai: this.state.searchData?.tanggalInvoiceMulai || null,
            tanggalInvoiceAkhir: this.state.searchData?.tanggalInvoiceAkhir || null,
        });
        

        await this.fetchData(
            {...request, mainDealer: md?.value},
            this.state.pagination.page,
            this.state.pagination.limit,
        );

        this.setState((prevValue) => ({
            ...prevValue,
            mainDealer: md,
            submittedFilterData: request,
            loading: false,
        }));
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleSubmit = async (data) => {
        this.handleTriggerLoading();
        await this.save(data);
        this.handleShowDetail();
        let {mainDealer, mdOptions, submittedFilterData} = this.state;

        let md = mainDealer ? mainDealer : mdOptions[0];
        this.setState(prev => ({
            ...prev,
            mainDealer: md,
            skipNextPaginationFetch: true
        }));

        let req = removeNullFields({
            ...submittedFilterData,
            mainDealer: mainDealer?.value
        })

        await this.fetchData(
            req,
            this.state.pagination.page,
            this.state.pagination.limit
        );
        this.handleTriggerLoading();
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    save = async (requestBody) => {
        let {dataPackage, ...rest} = requestBody.salesOrderSubmitRequestDTO;
        let {selectedPackage, ...rest2} = dataPackage;
        return fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_DGI").submitDataSalesOrderDGI,
            setError: this.props.setError,
            menuName: "Faktur Jual - DGI",
            args: removeNullFields({
                ...requestBody,
                salesOrderSubmitRequestDTO: {
                    ...rest,
                    dataPackage: rest2,
                }
            }),
        })
    };

    triggerGetFJDGI = async () => {
        const { searchData, mainDealer } = this.state;

        this.setState(prev=>({
            ...prev,
            loading: true,
            submittedFilterData: {
                ...prev.submittedFilterData,
                tanggalInvoiceMulai: this.state.searchData?.tanggalInvoiceMulai || null,
                tanggalInvoiceAkhir: this.state.searchData?.tanggalInvoiceAkhir || null,
            }
        }))
        const res = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_DGI").manualTriggerGetFJDgi,
          setError: this.props.setError,
          menuName: "Faktur Jual - DGI",
          args: {
            kodeCabang: mainDealer?.kodeCabang,
            filterRequest: {
              filter: {
                mainDealer: mainDealer?.value || null,
                tanggalInvoiceMulai: searchData?.tanggalInvoiceMulai || null,
                tanggalInvoiceAkhir: searchData?.tanggalInvoiceAkhir || null,
              },
              page: 1,
              limit: this.state.pagination.limit,
            },
          },
        });
        
        if(res.ok && res.data.status === HttpStatus.SUCCESS){
             const enhancedData = res?.data?.data.map(item => {
                const [day, month, year] = item.tanggalInvoice.split("/");
                return {
                    ...item,
                    tanggalInvoice: M(new Date(+year, +month - 1, +day)).format("DD-MM-YYYY"),
                }
            });
            this.setState(prev => ({
                ...prev,
                dataTable: !R.isEmpty(res.data.data) ? enhancedData : [],
                skipNextPaginationFetch: true,
                pagination: {
                    ...prev.pagination,
                    page: 1,
                    totalData: res.data.totalData,
                },
            }))
        }
        this.setState({loading: false})
    }

    render() {
        return (
            <>
                <FakturJualSearch
                    tab="DGI"
                    state={this.state}
                    onSubmit={this.handleClickSearch}
                    onShowFilter={this.handleModalFilterVisibility}
                    onValueChange={this.handleValueChange}
                    onCabangChange={this.handleCabangChange}
                    onManualGetDGIData={this.triggerGetFJDGI}
                    menuAccess={this.props.menuAccess}
                />
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableColumns}
                    toCount={this.state.pagination.totalData}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                    // footerAdditionalButtons={
                    //     <SimpleButton
                    //         text="Cetak"
                    //         onClick={this.handlePrint}
                    //     />
                    // }
                />
                {this.state.filterVisible && (
                    <FakturJualDGIFilter
                        state={this.state}
                        onSetState={this.handleStateChange}
                        onClickClose={this.handleModalFilterVisibility}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}
                {this.state.detailVisible && (
                    <FakturJualDetail
                        tab="DGI"
                        formGroup={formGroup}
                        state={this.state}
                        visible={this.state.detailVisible}
                        onClickClose={() => this.handleShowDetail()}
                        onSubmit={this.handleSubmit}
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(FakturJualDGI);